module.exports = __webpack_public_path__ + "static/media/sneaky_peaky_2.fe5d9949.mp3";